import { c as _c } from "react/compiler-runtime";
import Ansi from 'ansi-to-react';
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { ConsoleLine } from '../../../../../../../../../typings/TransformationExecution.interface';
import Button from '../../../../../common/base/Button';
import Text from '../../../../../common/base/Text';
import Divider from '../../../../../common/base/Divider';
import { Div } from '../../../../../common/helpers/StyledUtils';
interface ConsoleProps {
  lines: ConsoleLine[];
  collapseable?: boolean;
  border_top?: boolean;
  onClear?: () => void;
  onToggleCollapse?: (collapsed: boolean) => void;
}
const StyledConsole = styled.div<{
  collapsed: boolean;
  border_top: boolean;
}>(({
  theme,
  collapsed,
  border_top
}) => css`
    width: 100%;
    max-height: ${collapsed ? 'none' : '320px'};
    background-color: ${theme.colors.surface.base.surface};

    ${border_top && css`
      border-top: ${theme.border};
    `}
  `);
const StyledConsoleScrollableContainer = styled(Div)<{
  dynamic_height?: boolean;
}>(({
  theme,
  dynamic_height
}) => css`
    padding: ${theme.spacing(4)} ${theme.spacing(6)};
    flex-grow: 1;
    overflow-y: auto;
    height: ${dynamic_height ? 'auto' : '250px'};
    background-color: ${theme.colors.surface.base.variant_surface_3};

    ${Div}:last-of-type {
      margin-bottom: 0 !important;
    }

    code {
      color: ${theme.colors.on.neutral.primary_neutral};
      font-weight: 400;
      background: transparent;
    }
  `);
const Console = t0 => {
  const $ = _c(21);
  const {
    lines,
    collapseable,
    border_top,
    onClear,
    onToggleCollapse
  } = t0;
  const [collapsed, setCollapsed] = useState(false);
  let t1;
  if ($[0] !== collapsed || $[1] !== onToggleCollapse) {
    t1 = () => {
      setCollapsed(!collapsed);
      onToggleCollapse && onToggleCollapse(!collapsed);
    };
    $[0] = collapsed;
    $[1] = onToggleCollapse;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggleCollapsed = t1;
  const t2 = border_top ?? false;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      justify: "space-between",
      align: "center",
      gap: 2
    };
    t4 = {
      y: 3,
      x: 6
    };
    t5 = <Text semi={true}>Console</Text>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== collapseable || $[7] !== collapsed || $[8] !== onClear || $[9] !== toggleCollapsed) {
    t6 = (collapseable || onClear) && <Div flex={{
      gap: 3
    }}>{onClear && <Button onClick={onClear} ghost={true} icon="delete">Clear console</Button>}{collapseable && <Button onClick={toggleCollapsed} ghost={true} icon={collapsed ? "arrow_dotted_up" : "arrow_dotted_down"} />}</Div>;
    $[6] = collapseable;
    $[7] = collapsed;
    $[8] = onClear;
    $[9] = toggleCollapsed;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Div flex={t3} p={t4}>{t5}{t6}</Div>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== collapsed || $[14] !== lines) {
    t8 = !collapsed && <><Divider /><Console.Container lines={lines} /></>;
    $[13] = collapsed;
    $[14] = lines;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== collapsed || $[17] !== t2 || $[18] !== t7 || $[19] !== t8) {
    t9 = <StyledConsole collapsed={collapsed} border_top={t2}>{t7}{t8}</StyledConsole>;
    $[16] = collapsed;
    $[17] = t2;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
Console.Container = ({
  lines,
  ...props
}) => {
  return <StyledConsoleScrollableContainer {...props}>
      {lines.length === 0 && <Text mono as="p" m={0} muted>
          No output yet.
        </Text>}
      {lines.map((line, i) => <Div m={{
      b: 2
    }} key={i}>
          <Text mono as="span" m={{
        r: 2
      }} danger={line.type === 'error'} warning={line.type === 'warn'} primary={line.type === 'log'} semi>
            {line.type.toUpperCase()}
          </Text>
          <Ansi>{line.message}</Ansi>
        </Div>)}
    </StyledConsoleScrollableContainer>;
};
export default Console;